import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    h: "Overview",
    b: "Vaultavo provides identity-bound digital asset custody and security infrastructure. This Privacy Notice describes the categories of personal data Vaultavo processes, the purposes of processing, the legal bases on which we rely, and the rights available to data subjects under applicable data protection law (including the EU/UK GDPR).\n\nThe full, counter-signed Privacy Notice is available upon request to compliance@vaultavo.com or via the Documentation Requests form in the Trust Centre.",
  },
  {
    h: "Biometric data",
    b: "Vaultavo's hardware architecture is designed so that biometric templates are enrolled, stored, and matched entirely within the Common Criteria EAL6+ High secure element on the Vaultavo Biometric Security Device. Biometric templates are not transmitted to Vaultavo backend infrastructure, are not stored in any central database, and are not accessible to Vaultavo personnel.",
  },
  {
    h: "Categories of data we process",
    b: "Where you submit an enquiry, request documentation, or engage with us commercially, we process limited business-contact information (name, role, company, business email, message content). Where institutional onboarding occurs, additional KYC and corporate documentation may be processed under a separate agreement.",
  },
  {
    h: "Purposes and legal bases",
    b: "We process personal data to respond to enquiries, deliver requested documentation, provide and operate the Vaultavo services under contract, comply with legal obligations, and pursue legitimate institutional interests in security, fraud prevention, and the integrity of our infrastructure.",
  },
  {
    h: "Retention",
    b: "Personal data is retained for the period necessary to fulfil the purpose for which it was collected, and thereafter only as required by law, regulation, or legitimate institutional interest (for example, audit trail and dispute resolution).",
  },
  {
    h: "Your rights",
    b: "Subject to applicable law, you have the right of access, rectification, erasure, restriction, objection, and data portability. To exercise these rights, contact hello@vaultavo.com.",
  },
  {
    h: "Contact",
    b: "Privacy and security enquiries: hello@vaultavo.com",
  },
];

export default function Privacy() {
  return (
    <LegalPage
      testid="privacy-page"
      kicker="Privacy Notice"
      title="How Vaultavo handles personal data."
      summary="A summary of the personal data Vaultavo processes, why we process it, and how we protect biometric and identity information."
      lastUpdated="Feb 2026"
      sections={SECTIONS}
    />
  );
}
